// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"styles_mainContent__3JT2n"};